import ChartingBaseController from './charting_base_controller';

export default class extends ChartingBaseController {
  static values = { actions: { type: Array, default: [] } };

  change() {
    const checked = [
      ...this.element.querySelectorAll('input[type="checkbox"]:checked')
    ].map((cb) => cb.value);

    this.applyActions(this.actionsValue, {
      value: checked,
      remove: !checked.length
    });
  }
}
